import { BannerStatic } from '../../components'
import * as actions from './slice'

const getSkillBite = ({ onError }) => ({
  eventName: 'adminSkillBiteGet',
  onSuccess: {
    action: actions.getSkillBite,
    redux: true
  },
  onError
})

const updateSkillBiteDetails = ({ onSuccess }) => ({
  eventName: 'adminSkillBiteUpdateDetails',
  onSuccess: [
    {
      action: actions.updateSkillBiteDetails,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill bite details have been successfully updated' })
    },
    onSuccess
  ],
  onError: (e) => {
    console.error('adminSkillBiteUpdateDetails', e)
    BannerStatic.show({ label: 'Error trying to save skill bite details', isError: true })
  }
})

const addSession = ({ onSuccess, onError }) => ({
  eventName: 'adminSkillBiteCreateSession',
  onSuccess: [
    {
      action: actions.addSession,
      redux: true
    },
    {
      action: actions.changeSelectedSession,
      redux: true
    },
    onSuccess
  ],
  onError
})

const updateSession = ({ onSuccess, onError }) => ({
  eventName: 'adminSkillBiteUpdateSession',
  onSuccess: [
    {
      action: actions.updateSession,
      redux: true
    },
    onSuccess
  ],
  onError
})

const updateSessionEmail = {
  eventName: 'adminSkillBiteUpdateSessionEmail',
  onSuccess: [
    {
      action: actions.updateSessionEmail,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill Bite Session Email Config has been successfully updated.' })
    }
  ],
  onError: (e) => {
    console.error('adminSkillBiteUpdateSessionEmail', e)
    BannerStatic.show({ label: 'Error trying to update session email.', isError: true })
  }
}

const addSection = ({ onSuccess, onError }) => ({
  eventName: 'adminSkillBiteInsertSessionSection',
  onSuccess: [
    {
      action: actions.addSection,
      redux: true
    },
    onSuccess
  ],
  onError
})

const renameSection = ({ onSuccess, onError }) => ({
  eventName: 'adminSkillBiteRenameSessionSection',
  onSuccess: [
    {
      action: actions.renameSection,
      redux: true
    },
    onSuccess
  ],
  onError
})

const addPage = {
  eventName: 'adminSkillBiteCreatePage',
  onSuccess: [
    {
      action: actions.addPage,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill Bite page has been successfully created' })
    }
  ],
  onError: (e) => {
    console.error('adminSkillBiteCreatePage', e)
    BannerStatic.show({ label: 'Error trying to create new page', isError: true })
  }
}

const deletePage = {
  eventName: 'adminSkillBiteDeletePage',
  onSuccess: [
    {
      action: actions.deletePage,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill Bite page has been successfully deleted' })
    }
  ],
  onError: (e) => {
    console.error('adminSkillBiteDeletePage', e)
    BannerStatic.show({ label: 'Error trying to delete page', isError: true })
  }
}

const deleteSkillBite = ({ onSuccess }) => ({
  eventName: 'adminSkillBiteDelete',
  onSuccess: [
    () => {
      BannerStatic.show({ label: 'Skill Bite has been successfully deleted.' })
    },
    onSuccess
  ],
  onError: (e) => {
    console.error('adminSkillBiteDelete', e)
    BannerStatic.show({ label: 'Error trying to delete skill bite', isError: true })
  }
})

const deleteSection = {
  eventName: 'adminSkillBiteDeleteSessionSection',
  onSuccess: [
    {
      action: actions.deleteSection,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill Bite section has been successfully deleted' })
    }
  ],
  onError: (e) => {
    console.error('adminSkillBiteDeleteSessionSection', e)
    BannerStatic.show({ label: 'Error trying to delete section', isError: true })
  }
}

const deleteSession = {
  eventName: 'adminSkillBiteDeleteSession',
  onSuccess: [
    {
      action: actions.deleteSession,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill Bite session has been successfully deleted' })
    }
  ],
  onError: (e) => {
    console.error('adminSkillBiteDeleteSession', e)
    BannerStatic.show({ label: 'Error trying to delete session', isError: true })
  }
}

const publishSkillBite = ({ onSuccess, onError }) => ({
  eventName: 'adminSkillBitePublish',
  onSuccess: [
    {
      action: actions.publishSkillBite,
      redux: true
    },
    () => {
      BannerStatic.show({ label: 'Skill Bite has been successfully published' })
    },
    onSuccess
  ],
  onError: [
    (e) => {
      console.error('adminSkillBitePublish', e)
      BannerStatic.show({ label: 'Error trying to publish the Skill Bite', isError: true })
    },
    onError
  ]
})

export {
  getSkillBite,
  deleteSection,
  deleteSession,
  updateSession,
  updateSessionEmail,
  updateSkillBiteDetails,
  addSession,
  addSection,
  renameSection,
  addPage,
  deletePage,
  deleteSkillBite,
  publishSkillBite
}
